import { useEffect, useRef } from 'react';
import { supabase } from '../services/supabaseClient';
import { notifyAppEnquiryWhatsApp } from '../services/appEnquiryWhatsAppService';

/**
 * Listen for new app enquiries while Admin portal is open (any page).
 * Server DB trigger also notifies — this is a realtime backup.
 */
export default function useAppEnquiryWhatsAppNotify(enabled = true) {
  const notifiedRef = useRef(new Set());

  useEffect(() => {
    if (!enabled) return undefined;

    const queueNotify = (type, id) => {
      if (!type || !id) return;
      const key = `${type}:${id}`;
      if (notifiedRef.current.has(key)) return;
      notifiedRef.current.add(key);
      // Always edge function — full payload + server-side dedup log
      notifyAppEnquiryWhatsApp(type, id, null);
    };

    const channel = supabase
      .channel('admin-app-enquiry-wa-notify')
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'car_loan_leads' },
        (payload) => queueNotify('car_loan', payload.new?.id),
      )
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'service_bookings' },
        (payload) => {
          if (String(payload.new?.service_type || '').startsWith('garage:')) {
            queueNotify('car_service', payload.new?.id);
          }
        },
      )
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'service_requests' },
        (payload) => {
          if (payload.new?.source === 'customer_rsa_app') {
            queueNotify('rsa', payload.new?.id);
          }
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [enabled]);
}
